import React from "react";
import { connect, } from "react-redux";
import {
	BrowserRouter as Router,
	Route,
	Link,
	Redirect,
	Switch,
} from "react-router-dom";

import Login from "./components/Login";
import Private from "./components/Private";
import ReceiveToken from "./components/ReceiveToken";
import AuthError from "./components/AuthError";
import NotFound from "./components/NotFound";
import Logout from "./components/Logout";
import ImageUpload from "./components/ImageUpload";
import Editor from "./components/Editor";

import LoadingOverlay from "./components/LoadingOverlay";

// --------------------------------------------------

const RestoringSpace = () => <h1>Restoring space...</h1>;

const mstp = ({ space, }) => ({ space, });

const PrivateRoute = connect(mstp)(
	({ component, space, dispatch, ...rest, }) => (
		<Route
			{ ...rest }
			render = {
				props => {
					if (space) {
						if (space.update) {
							return React.createElement(component, props);
						}
						else {
							dispatch({
								type: "RESTORE_SPACE",
							});
							return <RestoringSpace/>
						}
					}
					else {
						return <Redirect to = {{
							pathname: "/login",
							state: { from: props.location, },
						}}/>;
					}
				}
			}
		/>
	)
);

const RedirectToEditor = () => <Redirect to = "/editor"/>

// --------------------------------------------------

export default () => (
	<Router>
		<div>
			<Switch>
				<Route
					path = "/login"
					component = { Login }
				/>
				<Route
					path = "/logout"
					component = { Logout }
				/>
				<Route
					path = "/token"
					component = { ReceiveToken }
				/>
				<Route
					path = "/login-error"
					component = { AuthError }
				/>
				<PrivateRoute
					exact
					path = "/"
					component = { RedirectToEditor }
				/>
				<PrivateRoute
					path = "/upload"
					component = { ImageUpload }
				/>
				<PrivateRoute
					path = "/editor"
					component = { Editor }
				/>
				<Route
					component = { NotFound }
				/>
			</Switch>
			<LoadingOverlay/>
		</div>
	</Router>
);

// export default () => <p>lol</p>


// WEBPACK FOOTER //
// ./src/Router.js